import Vue from 'vue';

import UserInfo from './user-info/UserInfo.vue';
import PxStatusNegociacao from './PxStatusNegociacao.vue';
import PxSituacaoCompraIcon from './PxSituacaoCompraIcon.vue';
import PxStatusFeedback from './PxStatusFeedback.vue';
import PxProdutoEspecificacao from './PxProdutoEspecificacao.vue';
import PxBooleanSimNao from './PxBooleanSimNao.vue';
import PxResponsaveis from './responsaveis/PxResponsaveis.vue';
import PxAutocompleteUser from './PxAutocompleteUser.vue';
import PxPopoverComprador from './PxPopoverComprador.vue';
import PxAutocompleteFornecedorGrupoCompra from './PxAutocompleteFornecedorGrupoCompra.vue';
import PxAutocompleteCatalogo from './PxAutocompleteCatalogo.vue';
import PxOfertaFoto from './PxOfertaFoto.vue';
import PxOpenOferta from './PxOpenOferta.vue';
import PxOfertaDestaque from './PxOfertaDestaque.vue';
import PxAutocompleteUsers from './PxAutocompleteUsers.vue';
import PxAutocompleteConfiguracaoVenda from './PxAutocompleteConfiguracaoVenda.vue';
import PxAutocompleteCategoria from './PxAutocompleteCategoria.vue';
import PxOfertaPromocao from './PxOfertaPromocao.vue';
import PxInputTime from './PxInputTime.vue';
import PxAutocompleteGrade from './PxAutocompleteGrade.vue';
import PxOfertaGrade from './PxOfertaGrade.vue';
import PxCodigoInterno from './PxCodigoInterno.vue';
import PxViewModuleHeader from './ViewModuleHeader.vue';
import PxViewHeaderTitle from './PxViewHeaderTitle.vue';
import PxAutocompleteConfiguracaoFrete from './PxAutocompleteConfiguracaoFrete.vue';

Vue.component('pxUserInfo', UserInfo);
Vue.component('PxStatusNegociacao', PxStatusNegociacao);
Vue.component('PxStatusNegociacao', PxStatusNegociacao);
Vue.component('PxSituacaoCompraIcon', PxSituacaoCompraIcon);
Vue.component('PxStatusFeedback', PxStatusFeedback);
Vue.component('PxProdutoEspecificacao', PxProdutoEspecificacao);
Vue.component('PxBooleanSimNao', PxBooleanSimNao);
Vue.component('PxResponsaveis', PxResponsaveis);
Vue.component('PxAutocompleteUser', PxAutocompleteUser);
Vue.component('PxPopoverComprador', PxPopoverComprador);
Vue.component('PxAutocompleteFornecedorGrupoCompra', PxAutocompleteFornecedorGrupoCompra);
Vue.component('PxAutocompleteCatalogo', PxAutocompleteCatalogo);
Vue.component('PxOfertaFoto', PxOfertaFoto);
Vue.component('PxOpenOferta', PxOpenOferta);
Vue.component('PxOfertaDestaque', PxOfertaDestaque);
Vue.component('PxAutocompleteUsers', PxAutocompleteUsers);
Vue.component('PxAutocompleteConfiguracaoVenda', PxAutocompleteConfiguracaoVenda);
Vue.component('PxAutocompleteCategoria', PxAutocompleteCategoria);
Vue.component('PxOfertaPromocao', PxOfertaPromocao);
Vue.component('PxInputTime', PxInputTime);
Vue.component('PxAutocompleteGrade', PxAutocompleteGrade);
Vue.component('PxOfertaGrade', PxOfertaGrade);
Vue.component('PxCodigoInterno', PxCodigoInterno);
Vue.component('PxViewModuleHeader', PxViewModuleHeader);
Vue.component('PxViewHeaderTitle', PxViewHeaderTitle);
Vue.component('PxAutocompleteConfiguracaoFrete', PxAutocompleteConfiguracaoFrete);
